import { gql } from 'apollo-boost';

export const REDO_ADMIN_DATA_EXPORT = gql`
    mutation RedoAdminDataExport($id: ID!, $fullAccount: Boolean) {
        redoAdminDataExport(id: $id, fullAccount: $fullAccount) {
            id
            status
            attempts
            error
            declinedAt
            declinedReason
            cancelledAt
            createdAt
            updatedAt
        }
    }
`;
